import { z } from "zod";

export const UpdateDocumentCategoryBodySchema = z.object({
    documentCategoryId: z.string().uuid().nullable(),
});
